import { render } from "./PuzzleBankView.vue?vue&type=template&id=6c2c3cc6"
import script from "./PuzzleBankView.vue?vue&type=script&lang=js"
export * from "./PuzzleBankView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__